import { useEffect, useState } from "react"

import { Form, InputNumber, Space, Text } from "@/atoms"
import { useFilters, useStateFilter } from "@/hooks/useFilters"
import { useLogger } from "@/hooks/useLogger"
import { DropdownFilter } from "../DropdownFilter"

import styles from "./KodemScoreFilter.module.scss"

export const KodemScoreFilter = ({
  isLoading,
  placement,
  maxValue = 10,
  placeHolderDefaultValue = "Kodem Score",
  label = placeHolderDefaultValue,
  prefix = "KS ≥"
}: any) => {
  const [error, setError] = useState(false)
  const { searchParams, setSearchParams } = useFilters()
  const { logger, EVENTS } = useLogger()
  const createInitialValues = (
    currentSearchParams: URLSearchParams = searchParams
  ) => ({
    kodemScore: currentSearchParams.get("kodemScore") || 0
  })
  const onChangeState = (
    prev: Record<string, any>,
    values: Record<string, any>
  ) => {
    const next = new URLSearchParams(prev)
    const value = Number(values.kodemScore)

    if (value !== 0) next.set("kodemScore", `${value}`)
    else next.delete("kodemScore")

    return next
  }
  const { filterState, reset, onFilterStateChange, onOk } = useStateFilter(
    createInitialValues(),
    { onChangeState, setSearchParams }
  )
  const value = Number(filterState.values.kodemScore)
  const validation = (value: number | string | null) => {
    const number = Number(value)

    if (number > maxValue || number < 0) {
      setError(true)
    } else {
      setError(false)
    }
  }

  const menuItems = [
    {
      key: "kodemScore",
      label: (
        <Form.Item
          className={styles.formItem}
          validateStatus={error ? "error" : undefined}
          extra={error ? `Insert a value between 0-${maxValue}` : undefined}
        >
          <Space>
            <Text>{label}</Text>
            <InputNumber
              step={1}
              precision={0}
              placeholder={placeHolderDefaultValue}
              defaultValue={0}
              value={Number(filterState.values.kodemScore)}
              onInput={validation}
              onChange={(value) => {
                validation(value)

                const kodemScore = value || 0

                onFilterStateChange({ kodemScore })

                logger.info(EVENTS.ANALYTIC_EVENTS.TAB.FILTER.QUICK_FILTERS, {
                  placement,
                  kodemScore,
                  name: "KodemScore"
                })
              }}
            />
          </Space>
        </Form.Item>
      )
    }
  ]

  useEffect(() => {
    const result = menuItems.some(({ key }: any) => {
      const checked = filterState.values[key]
      const checkedInUrl = searchParams.get(key)

      return String(checked) !== String(checkedInUrl)
    })

    if (result) {
      reset(createInitialValues())
    }

    onOk()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  const originalValues = createInitialValues(searchParams).kodemScore

  return (
    <DropdownFilter
      disabled={isLoading}
      changed={filterState.changed}
      menuItems={menuItems}
      isPlaceholder={originalValues === 0}
      clearDisabled={value === 0}
      okDisabled={!filterState.dirty || error}
      onOpenChange={(open: boolean) => {
        if (open) {
          reset(createInitialValues(), false)
        }
      }}
      onClear={() => onFilterStateChange({ kodemScore: 0 })}
    >
      {`${prefix} ${originalValues}`}
    </DropdownFilter>
  )
}
